interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

function buildPages(current: number, total: number): (number | '...')[] {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const pages: (number | '...')[] = [1];
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  if (start > 2) pages.push('...');
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (end < total - 1) pages.push('...');
  pages.push(total);
  return pages;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;
  const pages = buildPages(current, total);

  const baseBtn =
    'flex h-10 min-w-10 items-center justify-center rounded-md px-3 text-sm font-medium transition-colors';

  return (
    <div className="flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        disabled={current <= 1}
        onClick={() => onChange(current - 1)}
        className={`${baseBtn} border border-background-700 text-foreground-200 hover:border-primary-600 hover:text-primary-400 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-700 disabled:hover:text-foreground-200`}
      >
        <i className="ri-arrow-left-s-line text-lg" />
        <span className="hidden sm:inline">上一页</span>
      </button>

      {pages.map((p, i) =>
        p === '...' ? (
          <span key={`ellipsis-${i}`} className="px-1 text-foreground-500">
            ···
          </span>
        ) : (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={`${baseBtn} ${
              p === current
                ? 'bg-primary-500 text-background-950'
                : 'border border-background-700 text-foreground-200 hover:border-primary-600 hover:text-primary-400'
            }`}
          >
            {p}
          </button>
        ),
      )}

      <button
        type="button"
        disabled={current >= total}
        onClick={() => onChange(current + 1)}
        className={`${baseBtn} border border-background-700 text-foreground-200 hover:border-primary-600 hover:text-primary-400 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-700 disabled:hover:text-foreground-200`}
      >
        <span className="hidden sm:inline">下一页</span>
        <i className="ri-arrow-right-s-line text-lg" />
      </button>
    </div>
  );
}